<template>
  <div class="main-power">
    <div class="power-content" id="power-content">
      <div class="power-top">
        <div class="power-top-text">{{ $t('series.power_supply') }}</div>
        <div class="power-top-card">
          <img v-if="this.$i18n.locale === 'zh'" src="../../static/home/power.png" alt="">
          <img v-else src="../../static/home/power1.png" alt="">
        </div>
      </div>
      <div class="power-bottom-text">{{ $t('series.Dimensions') }}</div>
      <div class="power-bottom">
        <div class="power-bottom-card">
          <img style="width: 115%" v-if="this.$i18n.locale === 'zh'" src="../../static/home/work1.png" alt="">
          <img style="width: 115%" v-else src="../../static/home/work1-1.png" alt="">
        </div>
        <div class="power-bottom-card">
          <img style="width: 115%" v-if="this.$i18n.locale === 'zh'" src="../../static/home/work2.png" alt="">
          <img style="width: 115%" v-else src="../../static/home/work2-1.png" alt="">
        </div>
        <div class="power-bottom-card">
          <img style="width: 115%" v-if="this.$i18n.locale === 'zh'" src="../../static/home/work3.png" alt="">
          <img style="width: 115%" v-else src="../../static/home/work3-1.png" alt="">
        </div>
        <div class="power-bottom-card">
          <img style="width: 115%" v-if="this.$i18n.locale === 'zh'" src="../../static/home/work4.png" alt="">
          <img style="width: 115%" v-else src="../../static/home/work4-1.png" alt="">
        </div>
        <div class="power-bottom-card">
          <img style="width: 115%" v-if="this.$i18n.locale === 'zh'" src="../../static/home/work5.png" alt="">
          <img style="width: 115%" v-else src="../../static/home/work5-1.png" alt="">
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import img2 from '../../static/home/background_power.png'

export default {
  name: 'PowerAndWorking',
  data() {
    return {
      power_img: img2
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.$gsap.set(['.power-top-text',
        '.power-top-card',
        '.power-bottom-text',
        '.power-bottom',
      ], {
        opacity: 0
      })

      const masterTimeline = this.$gsap.timeline({
        scrollTrigger: {
          trigger: ['.main-power'],
          start: 'top 80%',
          end: 'bottom 0%',
          markers: false,
          // scrub: 1,
          // once: true,
          toggleActions: 'play none none reverse'
        }
      })

      const powerContent = document.getElementById('power-content')
      masterTimeline.from('.power-content', {
        opacity: 0,
        duration: 1.5,
        ease: 'power2.in',
        y: 50,
        onComplete: () => {
          powerContent.style.backgroundImage = `url('${this.power_img}')`
        }
      }, 0.2)

      masterTimeline.to('.power-top-text', {
        opacity: 1,
        duration: 1.5,
        y: -50,
        ease: 'power2.in'
      }, 0.4)

      masterTimeline.to('.power-top-card', {
        opacity: 1,
        duration: 1.5,
        y: -50,
        ease: 'power2.in'
      }, 1.5)
      //
      masterTimeline.to('.power-bottom-text', {
        opacity: 1,
        duration: 1.5,
        y: -50,
        ease: 'power2.out'
      }, 2.5)
      //
      masterTimeline.to('.power-bottom', {
        opacity: 1,
        duration: 1.5,
        y: -50,
        ease: 'power2.out'
      }, 3.5)

      // masterTimeline.to('.main-power', {
      //   opacity: 0,
      //   y: -100,
      //   duration: 1,
      //   ease: 'power2.out'
      // }, 5)
    })
  }
}
</script>
<style scoped>
.main-power {
  width: 100%;
  height: 1000px;
  margin-top: 200px;
}

.power-content {
  width: 80%;
  height: 800px;
  background-image: url("../../static/home/background_blurry.png");
  background-repeat: no-repeat;
  background-position: 150px center;
  margin: 0 auto;
  margin-bottom: 20px;
}

.power-top {
  padding-top: 150px;
}

.power-top-card {
  display: flex;
  justify-content: center;
  width: 100%;
  height: 180px;
  border-radius: 10px;
  background-color: #e8e8e8;
  margin: 0 auto;
  align-items: center;

  img {
    width: 90%;
  }
}

.power-top-text {
  font-size: 1.2em;
  color: black;
  text-align: left;
  margin-bottom: 10px;
}

.power-bottom {
  padding-top: 10px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 105%;
}

.power-bottom-text {
  font-size: 1.2em;
  color: black;
  text-align: left;
  margin-top: 30px;
}

.power-bottom-card {
  height: 450px;
  background-color: white;
  width: 17%;
  border-radius: 30px;

  img {
    width: 150%;
    margin: 0 auto;
  }
}
</style>
